import axios from "axios";

export const enviarNotificacionPrueba = async (entidad) => {

    let data = JSON.stringify(entidad);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
      //  url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/877206db-e382-4b53-bc67-e5c8c054b068', //test
       url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/877206db-e382-4b53-bc67-e5c8c054b068',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    axios.request(config)
        .then((response) => {
            console.log(JSON.stringify(response.data));
            return true
        })
        .catch((error) => {
            console.log(error);
            return false
        });

}